export const blockIconsMapsRestaurant = (
	<span className='material-symbols-outlined'>restaurant</span>
);
